"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function FiftyThree() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="featuredfiftythreefoot" data-nav="light" className="w-full bg-background py-12 md:py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.24,
        ease: [0.16, 1, 0.3, 1]
      }} className="rounded-lg border border-border bg-card p-6 shadow-sm md:p-8 lg:p-10">
          <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
            {/* Left Column: Image Container */}
            <div className="w-full overflow-hidden rounded-lg border border-border shadow-xs">
              <AspectRatio ratio={16 / 11}>
                <img src="https://fridgefleet.com/wp-content/uploads/2026/09/FF-Reefer-trailer.png" data-wvc-srcset="https://fridgefleet.com/wp-content/uploads/2026/09/FF-Reefer-trailer.png-wvc-srcset" data-wvc-sizes="https://fridgefleet.com/wp-content/uploads/2026/09/FF-Reefer-trailer.png-wvc-sizes" alt="Fridge Fleet 53-foot reefer trailer for temporary refrigerated storage" loading="lazy" decoding="async" className="h-full w-full object-cover" />
              </AspectRatio>
            </div>

            {/* Right Column: Content */}
            <div className="flex flex-col justify-center">
              <h2 className="font-default text-2xl font-bold tracking-tight text-foreground sm:text-3xl lg:text-4xl">
                53-Foot Reefer Trailer for Commercial Needs
              </h2>
              <p className="mt-4 text-base leading-relaxed text-muted-foreground">
                The 53-foot reefer trailer may provide large-capacity temporary
                refrigerated storage for food distribution, grocery operations,
                catering, events, emergency cold storage, and commercial
                projects. Availability, specifications, delivery requirements,
                intended use, and temperature requirements are confirmed
                individually.
              </p>

              {/* Action Buttons */}
              <div className="mt-8 flex flex-wrap items-center gap-4">
                <Button asChild variant="default" size="lg">
                  <Link to="/FootRefrigeratedTrailerRentalsPage" className="flex items-center gap-2">
                    <span>View 53-Foot Reefer Trailer</span>
                    <ArrowRight className="size-4" />
                  </Link>
                </Button>

                <Button asChild variant="outline" size="lg">
                  <Link to="/ContactRequestAQuotePage" className="flex items-center gap-2">
                    <FileText className="size-4" />
                    <span>Request a Quote</span>
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}